<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-th-large"></i>
        <h1>הוספת נוכחות קבועה</h1>
      </template>
      <div class="p-p-4 p-fluid p-grid">
        <div class=" p-col-6 p-md-6">
          <label for="displayName">תלמיד</label>
            <select-pupil  navigate-buttons useStore storage-name="presence-const-add" @onSelect="onSelectPupil"/>

        </div>
          <div class=" p-fluid p-col-12 p-md-6">
          <label for="displayName">תיאור</label>

            <InputText  type="text" v-model="newItem.description" autofocus />
        </div>
        <div class="p-fluid p-col-12 p-md-6">
          <label for="displayName">סיבה</label>

            <InputText  type="text" v-model="newItem.reason" autofocus />
        </div>
          <div class="p-fluid p-col-12 p-md-6">
          <label for="displayName">ימיים בשבוע</label>
              <MultiSelect
                      v-model="newItem.daysInWeek"
                      :options="[1,2,3,4,5,6,7]"
                      placeholder="ימים בשבוע"
              />
        </div>
          <div class="p-fluid p-col-12 p-md-6">
          <label for="displayName">שיעור</label>
              <multi-select-lesson-time useStore storage-name="presence-const-add"  v-model="newItem.lessonTimes" return-id/>


        </div>
        <div class="p-fluid p-col-3 p-md-3">
          <label for="startDate">תאריך התחלה</label>
            <calendar  v-model="newItem.startDate" />
        </div>
          <div class="p-fluid p-col-3 p-md-3">
          <label for="endDate">תאריך סוף</label>
          <calendar  v-model="newItem.endDate" />
        </div>
          <div class="p-fluid p-col-1 p-md-1">
              <label for="startDate">צבע</label>
              <ColorPicker
                      v-model="newItem.color"
              />
          </div>
      </div>




        <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";

const { v4: uuidv4 } = require("uuid");
import SelectPupil from "@/components/selects/SelectPupil.vue";
import MultiSelectLessonTime from "@/components/selects/MultiSelectLessonTime.vue";
import Service from "../../../service/Service";
export default {
    components: {
        SelectPupil,
        MultiSelectLessonTime,
    },
  service: null,
  props: {
    show: Boolean,
  },
  created() {
    this.service = new Service();
      this.setNewItwmFields();

  },
  data() {
    return {
      newItem: null,
    };
  },
    computed: {
        ...mapState(["user", "reportRanges"]),
    },
  methods: {
      getRelevantDate(){
           const a= this.reportRanges?.filter(report => !report.forOldShow && !report.forAdminOnly)
          console.log(a)
          return a[0]
      },
      getStartDate(){
          return new Date(this.getRelevantDate()?.startDate)
      },
      getEndDate(){
          return new Date(this.getRelevantDate()?.endDate)
      },
      setNewItwmFields() {
      this.newItem = {
          id: uuidv4(),
          date: new Date(),
          daysInWeek: [],
          pupil: null,
          lessonTimes: null,
          color: "7f0dde",
          description: "",
          user: this.user.id,
          reason: "",
          active:true,
          startDate: this.getStartDate(),
          endDate: this.getEndDate(),
      };
    },
      onSelectPupil(pupil){
        this.newItem.pupil = pupil
      },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      for (const key in this.newItem) {
        if (this.newItem[key] === null) {
            console.log(key)
            console.log(this.newItem[key])
          validate = false;
        }
      }

      if (validate === true) {

          const clone = {...this.newItem}
          clone.date = this.newItem.date.getTime()
          clone.startDate = this.newItem.startDate.getTime()
          clone.endDate = this.newItem.endDate.getTime()
        await this.service
          .post(clone, "constant-presence")
          .then((data) => {
            this.$emit("addItem", clone);
            this.setNewItwmFields();
            this.openNotification(
              "success",
              `מעולה`,
              `התווסף בהצלחה`
            );

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `לא הצלחנו לעדכן במערכת`
            );
          });
      } else {
          console.log()
        this.openNotification(
          "danger",
          `אופס`,
          `חלק מהשדות חסרים או שגויים`
        );
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>